export const CSSVars = {
    BackgroundColor: '--sas-report-background-color',
    Padding: '--sas-report-padding',
};
